import UIComponent from "../../common/UIComponent";
import "./index.css";

export default class H5Progress extends UIComponent {

  constructor(elementId, interfaces) {
    super();
    this.interfaces = interfaces;
    this.elementId = elementId;
    this.init();

    this.interfaces.on(VhallPlayer.TIMEUPDATE, () => {

      // TODO: 解决IOS上 IndexSizeError: The index is not in the allowed range.  报错
      if (this.interfaces.getBuffered().length <= 0) { return; }
      const progressLoadValue = ((this.interfaces.getBuffered().end(this.interfaces.getBuffered().length - 1) / this.interfaces.getDuration()) * 100);
      this.progressLoad.style.width = progressLoadValue + "%";

      // seek状态时 不设置进度条的值
      if (this.isSeeking) { return; }

      const progressPlayValue = ((this.interfaces.getCurrentTime() / this.interfaces.getDuration()) * 100);
      this.progressPlay.style.width = progressPlayValue + "%";
      this.scrubber.style.left = progressPlayValue + "%";
    });
  }

  init() {

    this.progressContainer = document.createElement("div");
    this.progressContainer.setAttribute("class", "vhallPlayerh5-progress-container");
    this.progressContainer.onclick = this.handleProgressClick.bind(this)

    this.progressLoad = document.createElement("div");
    this.progressLoad.setAttribute("class", "vhallPlayerh5-progress-load");

    this.progressPlay = document.createElement("div");
    this.progressPlay.setAttribute("class", "vhallPlayerh5-progress-play");

    this.scrubber = document.createElement("div");
    this.scrubber.setAttribute("class", "vhallPlayerh5-progress-scrubber");
    this.scrubber.innerHTML = `<i></i>`;
    this.scrubber.ontouchstart = this.handleScrubberMouseDown.bind(this);

    this.progressContainer.appendChild(this.progressLoad);
    this.progressContainer.appendChild(this.progressPlay);
    this.progressContainer.appendChild(this.scrubber);

    this.appendChild(this.elementId, this.progressContainer);
  }


  handleProgressClick(event) {
    const mouseX = event.pageX - this.progressContainer.offsetLeft;
    const progressTime = mouseX / this.progressContainer.offsetWidth * this.interfaces.getDuration();
    this.scrubber.style.left = mouseX / this.progressContainer.offsetWidth * 100 + '%';
    this.progressPlay.style.width = mouseX / this.progressContainer.offsetWidth * 100 + '%';
    this.interfaces.setCurrentTime(progressTime);
    this.progressLoad.style.width = 0 + "%";
  }

  handleScrubberMouseDown(event) {
    this.isScrubberDown = true;
    this.isSeeking = true;
    const scrubberLeft = this.scrubber.offsetLeft;
    const mouseX = event.targetTouches[0].clientX;
    let progressValue = null;
    document.ontouchmove = event => {
      const moveL = event.targetTouches[0].clientX - mouseX;
      const newL = scrubberLeft + moveL + this.scrubber.offsetWidth / 2;
      progressValue = newL / this.progressContainer.offsetWidth * 100;
      if (newL / this.progressContainer.offsetWidth < 0 || newL / this.progressContainer.offsetWidth > 1) { return; }
      this.scrubber.style.left = newL / this.progressContainer.offsetWidth * 100 + '%';
      this.progressPlay.style.width = newL / this.progressContainer.offsetWidth * 100 + '%';
    }
    document.ontouchend = () => {
      if (this.isScrubberDown) {
        this.interfaces.setCurrentTime(progressValue / 100 * this.interfaces.getDuration());
        this.progressLoad.style.width = 0 + "%";
        this.isSeeking = false;
        this.isScrubberDown = false;
        document.ontouchmove = null;
        document.ontouchend = null;
      }

    }
  }

}